<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('journeysCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="journey-workspace"
         [class.journey-workspace--loading]="isLoading">
      <mat-card class="journey-panel journey-panel--detail"
                [class.journey-panel--view]="isViewMode"
                [class.journey-panel--editor]="isCreateMode || isEditMode">
        <div class="journey-panel__header"
             [class.journey-panel__header--editor]="isCreateMode || isEditMode">
          <div class="journey-panel__heading"
               [class.journey-panel__heading--editor]="isCreateMode || isEditMode">
            @if (isCreateMode || isEditMode) {
            <div class="journey-panel__heading-icon" aria-hidden="true">
              <mat-icon>{{ isCreateMode ? 'add_task' : 'edit_calendar' }}</mat-icon>
            </div>
            }
            <div class="journey-panel__heading-copy">
            <span class="journey-panel__eyebrow">{{ 'journeysCatalog.breadcrumb' | translate }}</span>
            <h3>{{ detailTitle }}</h3>
            <p>{{ detailDescription }}</p>
            </div>
          </div>
          <div class="journey-panel__actions">
            @if (selectedJourney && isViewMode) {
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-primary"
                    *appCanAccess="updateAccess"
                    (click)="startEdit()">
              <mat-icon>edit</mat-icon>
              {{ 'common.update' | translate }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-danger"
                    *appCanAccess="deleteAccess"
                    (click)="deleteSelected()">
              <mat-icon>delete_outline</mat-icon>
              {{ 'common.delete' | translate }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="goBackToList()">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.back' | translate }}
            </button>
            }
            @if (isCreateMode || isEditMode) {
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="cancelEdit()"
                    [disabled]="isSaving">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.cancel' | translate }}
            </button>
            <button mat-flat-button
                    type="button"
                    class="btn-tone-primary"
                    (click)="save()"
                    [disabled]="isSaving || !canSave">
              <mat-icon>save</mat-icon>
              {{ isCreateMode ? 'Crear jornada' : ('common.saveChanges' | translate) }}
            </button>
            }
          </div>
        </div>

        <div class="journey-panel__body">
          @if (isCreateMode || isEditMode) {
          <div class="journey-editor journey-editor--guided">
            <div class="journey-editor__main">
            <div class="card journey-editor__section mb-0">
              <div class="card-body">
                <div class="journey-section-heading">
                  <span class="journey-section-heading__step">1</span>
                  <div class="journey-section-heading__copy">
                    <div class="journey-section-heading__title">
                      <h4>{{ 'journeysCatalog.sections.general' | translate }}</h4>
                      <span class="journey-required-badge">{{ 'common.requiredLabel' | translate }}</span>
                    </div>
                    <p>{{ 'journeysCatalog.sections.generalDescription' | translate }}</p>
                  </div>
                </div>

                <div class="row g-3">
                  @if (hasMultipleCompanies) {
                  <div class="col-12 col-xl-4">
                    <app-company-select [records]="companies" [value]="form.companiesRecordId"
                                        [label]="'orgUnitsCatalog.fields.company' | translate"
                                        [placeholder]="'orgUnitsCatalog.fields.company' | translate"
                                        [disabled]="isSaving"
                                        (valueChange)="form.companiesRecordId = $event; selectedCompanyId = $event; onCompanyChange()" />
                  </div>
                  }
                  <div class="col-12 col-md-6"
                       [class.col-xl-4]="hasMultipleCompanies"
                       [class.col-xl-6]="!hasMultipleCompanies">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'journeysCatalog.fields.name' | translate }}</mat-label>
                      <mat-icon matPrefix>badge</mat-icon>
                      <input matInput
                             [(ngModel)]="form.name"
                             [disabled]="isSaving"
                             [placeholder]="'journeysCatalog.fields.namePlaceholder' | translate">
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-md-6"
                       [class.col-xl-4]="hasMultipleCompanies"
                       [class.col-xl-6]="!hasMultipleCompanies">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'journeysCatalog.fields.journeyType' | translate }}</mat-label>
                      <mat-icon matPrefix>schedule</mat-icon>
                      <mat-select [(ngModel)]="form.journeyType"
                                  [disabled]="isSaving">
                        @for (journeyType of journeyTypes; track journeyType) {
                        <mat-option [value]="journeyType">{{ ('journeysCatalog.journeyTypeOptions.' + journeyType) | translate }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <div class="card journey-editor__section mb-0">
              <div class="card-body">
                <div class="journey-section-heading">
                  <span class="journey-section-heading__step">2</span>
                  <div class="journey-section-heading__copy">
                    <div class="journey-section-heading__title">
                      <h4>{{ 'journeysCatalog.sections.workload' | translate }}</h4>
                      <span class="journey-required-badge">{{ 'common.requiredLabel' | translate }}</span>
                    </div>
                    <p>{{ 'journeysCatalog.sections.workloadDescription' | translate }}</p>
                  </div>
                </div>

                <div class="row g-3 journey-workload-grid">
                  <div class="col-12 journey-work-duration-column">
                    <div class="journey-duration-control journey-duration-control--combined">
                      <div class="journey-duration-control__heading">
                        <div>
                          <strong>Duración efectiva</strong>
                          <span>Captura el tiempo como normalmente lo expresas.</span>
                        </div>
                        <mat-icon>schedule</mat-icon>
                      </div>
                      <div class="journey-duration-control__inputs">
                        <mat-form-field subscriptSizing="dynamic" appearance="outline">
                          <mat-label>Horas</mat-label>
                          <input matInput
                                 type="number"
                                 min="0"
                                 step="1"
                                 inputmode="numeric"
                                 [ngModel]="workDurationHours"
                                 [ngModelOptions]="{standalone: true}"
                                 (ngModelChange)="onWorkHoursChange($event)"
                                 [disabled]="isSaving"
                                 placeholder="8">
                          <span matTextSuffix>h</span>
                        </mat-form-field>
                        <mat-form-field subscriptSizing="dynamic" appearance="outline">
                          <mat-label>Minutos</mat-label>
                          <input matInput
                                 type="number"
                                 min="0"
                                 max="59"
                                 step="1"
                                 inputmode="numeric"
                                 [ngModel]="workDurationMinutes"
                                 [ngModelOptions]="{standalone: true}"
                                 (ngModelChange)="onWorkMinutesChange($event)"
                                 [disabled]="isSaving"
                                 placeholder="0">
                          <span matTextSuffix>min</span>
                        </mat-form-field>
                      </div>
                      <div class="journey-duration-presets" aria-label="Duraciones frecuentes">
                        <span>Duraciones frecuentes:</span>
                        @for (preset of [480, 540, 600]; track preset) {
                        <button type="button"
                                [class.active]="isWorkDurationSelected(preset)"
                                [disabled]="isSaving"
                                (click)="setWorkDuration(preset)">
                          {{ getWorkMinutesLabel(preset) }}
                        </button>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="col-12 journey-meal-toggle-column"
                       [class.journey-meal-toggle-column--full]="!form.includesMealBreak">
                    <div class="journey-toggle-card">
                      <div class="journey-toggle-card__content">
                        <span class="journey-toggle-card__icon"><mat-icon>local_cafe</mat-icon></span>
                        <div>
                          <strong>{{ 'journeysCatalog.fields.includesMealBreak' | translate }}</strong>
                          <p>{{ 'journeysCatalog.fields.includesMealBreakHint' | translate }}</p>
                        </div>
                      </div>
                      <div class="journey-toggle-card__action">
                        <mat-slide-toggle [(ngModel)]="form.includesMealBreak"
                                          [disabled]="isSaving"
                                          (ngModelChange)="onMealBreakToggle()">
                        </mat-slide-toggle>
                        <span>Incluir tiempo de comida</span>
                      </div>
                    </div>
                  </div>
                  @if (form.includesMealBreak) {
                  <div class="col-12 journey-meal-duration-column">
                    <div class="journey-meal-minutes-field">
                      <mat-form-field subscriptSizing="dynamic" appearance="outline">
                        <mat-label>Minutos de comida</mat-label>
                        <input matInput
                               type="number"
                               min="1"
                               step="1"
                               inputmode="numeric"
                               [(ngModel)]="form.mealBreakMinutes"
                               [disabled]="isSaving"
                               placeholder="30">
                        <span matTextSuffix>min</span>
                      </mat-form-field>
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
            </div>

            <aside class="journey-form-summary">
              <div class="journey-form-summary__heading">
                <span><mat-icon>description</mat-icon></span>
                <div>
                  <h4>Resumen de la jornada</h4>
                  <p>Vista previa con los valores capturados.</p>
                </div>
              </div>

              <div class="journey-form-summary__validation"
                   [class.journey-form-summary__validation--ready]="canSave">
                <mat-icon>{{ canSave ? 'check' : 'priority_high' }}</mat-icon>
                <div>
                  <strong>{{ canSave ? 'Configuración válida' : 'Configuración pendiente' }}</strong>
                  <span>{{ canSave ? 'Puedes guardar esta jornada.' : 'Completa los campos obligatorios.' }}</span>
                </div>
              </div>

              <div class="journey-form-summary__metrics">
                <div>
                  <span class="journey-form-summary__metric-icon"><mat-icon>schedule</mat-icon></span>
                  <span>Duración efectiva<strong>{{ getWorkMinutesLabel(formPreviewWorkMinutes) }}</strong></span>
                </div>
                <div>
                  <span class="journey-form-summary__metric-icon journey-form-summary__metric-icon--meal"><mat-icon>local_cafe</mat-icon></span>
                  <span>Tiempo de comida<strong>{{ form.includesMealBreak ? getWorkMinutesLabel(formPreviewMealMinutes) : 'Sin comida' }}</strong></span>
                </div>
                <div>
                  <span class="journey-form-summary__metric-icon"><mat-icon>more_time</mat-icon></span>
                  <span>Tiempo total de la jornada<strong>{{ getWorkMinutesLabel(formPreviewTotalMinutes) }}</strong></span>
                </div>
              </div>

              <div class="journey-form-summary__note">
                <mat-icon>info</mat-icon>
                <span><strong>Nota</strong>El tiempo total incluye la duración efectiva más el tiempo de comida.</span>
              </div>
            </aside>
          </div>
          } @else if (selectedJourney; as journey) {
          <div class="journey-detail journey-detail--redesigned">
            <section class="journey-overview">
              <div class="journey-overview__identity">
                <div class="journey-overview__icon"><mat-icon>calendar_month</mat-icon></div>
                <div><span>{{ 'journeysCatalog.fields.name' | translate }}</span><strong>{{ journey.name }}</strong><small>{{ getCompanyName(journey.companiesRecordId) }}</small></div>
              </div>
              <div class="journey-overview__metrics">
                <div class="journey-overview-metric"><mat-icon>schedule</mat-icon><div><span>Tiempo efectivo</span><strong>{{ getWorkMinutesLabel(journey.workMinutes) }}</strong></div></div>
                <div class="journey-overview-metric"><mat-icon>swap_horiz</mat-icon><div><span>Tiempo total</span><strong>{{ getWorkMinutesLabel(journeyTotalMinutes) }}</strong></div></div>
                <div class="journey-overview-metric"><mat-icon>local_cafe</mat-icon><div><span>Comida</span><strong>{{ journey.includesMealBreak ? getWorkMinutesLabel(journeyMealMinutes) : ('journeysCatalog.labels.withoutMealBreak' | translate) }}</strong></div></div>
                <div class="journey-overview-metric journey-overview-metric--type"><mat-icon>{{ journeyTypeIcon }}</mat-icon><div><span>{{ 'journeysCatalog.fields.journeyType' | translate }}</span><strong>{{ getJourneyTypeLabel(journey.journeyType) }}</strong></div></div>
              </div>
              <div class="journey-status" [class.journey-status--inactive]="!journey.isActive"><i></i><div><strong>{{ journey.isActive ? ('common.status.active' | translate) : ('common.status.inactive' | translate) }}</strong><span>{{ journey.isActive ? 'Esta jornada está disponible para su uso.' : 'Esta jornada no está disponible para nuevas asignaciones.' }}</span></div></div>
            </section>

            <section class="journey-schedule-card">
              <div class="journey-card-heading"><mat-icon>date_range</mat-icon><div><h4>Distribución de la jornada</h4><p>Visualización proporcional del tiempo efectivo y de comida.</p></div></div>
              <div class="journey-timeline">
                <div class="journey-timeline__limits"><strong>Inicio</strong><strong>Fin</strong></div>
                <div class="journey-timeline__bar">
                  <span class="journey-timeline__work" [style.width.%]="journey.includesMealBreak ? journeyWorkSegmentPercent : 100"></span>
                  @if (journey.includesMealBreak) {
                  <span class="journey-timeline__meal" [style.width.%]="journeyMealSegmentPercent"></span>
                  <span class="journey-timeline__work" [style.width.%]="journeyWorkSegmentPercent"></span>
                  }
                </div>
                <div class="journey-timeline__labels" [class.journey-timeline__labels--without-meal]="!journey.includesMealBreak">
                  @if (journey.includesMealBreak) {
                  <div><strong>{{ getWorkMinutesLabel(journey.workMinutes / 2) }}</strong><span>Trabajo</span></div>
                  <div><strong>{{ getWorkMinutesLabel(journeyMealMinutes) }}</strong><span>Comida</span></div>
                  <div><strong>{{ getWorkMinutesLabel(journey.workMinutes / 2) }}</strong><span>Trabajo</span></div>
                  } @else {
                  <div><strong>{{ getWorkMinutesLabel(journey.workMinutes) }}</strong><span>Trabajo efectivo</span></div>
                  }
                </div>
              </div>
              <div class="journey-duration-strip">
                <div><mat-icon>schedule</mat-icon><span>Tiempo total<strong>{{ getWorkMinutesLabel(journeyTotalMinutes) }}</strong><small>Permanencia total</small></span></div>
                <div><mat-icon>local_cafe</mat-icon><span>Tiempo de comida<strong>{{ journey.includesMealBreak ? getWorkMinutesLabel(journeyMealMinutes) : '—' }}</strong><small>{{ journey.includesMealBreak ? 'Descanso configurado' : 'Sin comida' }}</small></span></div>
                <div><mat-icon>timer</mat-icon><span>Tiempo efectivo<strong>{{ getWorkMinutesLabel(journey.workMinutes) }}</strong><small>Tiempo laboral real</small></span></div>
              </div>
            </section>

            <div class="journey-detail-grid">
              <section class="journey-info-card">
                <div class="journey-card-heading"><mat-icon>settings</mat-icon><div><h4>Configuración general</h4><p>Información básica de la jornada.</p></div></div>
                <div class="journey-detail-list">
                  <div><span>{{ 'orgUnitsCatalog.fields.company' | translate }}</span><strong>{{ getCompanyName(journey.companiesRecordId) }}</strong></div>
                  <div><span>{{ 'journeysCatalog.fields.name' | translate }}</span><strong>{{ journey.name }}</strong></div>
                  <div><span>{{ 'journeysCatalog.fields.journeyType' | translate }}</span><strong>{{ getJourneyTypeLabel(journey.journeyType) }}</strong></div>
                  <div><span>{{ 'journeysCatalog.fields.includesMealBreak' | translate }}</span><strong>{{ getMealBreakLabel(journey) }}</strong></div>
                  <div><span>{{ 'journeysCatalog.fields.status' | translate }}</span><strong class="journey-active-value"><i></i>{{ journey.isActive ? ('common.status.active' | translate) : ('common.status.inactive' | translate) }}</strong></div>
                </div>
              </section>
              <section class="journey-info-card">
                <div class="journey-card-heading"><mat-icon>pie_chart</mat-icon><div><h4>Distribución del tiempo</h4><p>Resumen de los tiempos de la jornada.</p></div></div>
                <div class="journey-detail-list">
                  <div><span>Tiempo total (permanencia)</span><strong>{{ getWorkMinutesLabel(journeyTotalMinutes) }}</strong></div>
                  <div><span>Tiempo de comida</span><strong>{{ journey.includesMealBreak ? getWorkMinutesLabel(journeyMealMinutes) : '—' }}</strong></div>
                  <div><span>Tiempo efectivo (laboral)</span><strong>{{ getWorkMinutesLabel(journey.workMinutes) }}</strong></div>
                </div>
                <div class="journey-info-note"><mat-icon>info</mat-icon><span>El tiempo total se calcula sumando el tiempo efectivo y el tiempo de comida.</span></div>
              </section>
            </div>
          </div>
          } @else {
          <div class="journey-empty">
            <mat-icon>schedule</mat-icon>
            <h4>{{ 'journeysCatalog.emptyEditorTitle' | translate }}</h4>
            <p>{{ 'journeysCatalog.emptyEditorDescription' | translate }}</p>
          </div>
          }
        </div>
      </mat-card>

      @if (isLoading) {
      <app-loading-state class="journey-loading"
                         [message]="'journeysCatalog.loading' | translate" />
      }
    </div>
  </div>
</section>
